<ion-item class="form-element-wrapper form-field-phone" fill="outline" mode="md">
  @if (label) {
    <ion-label position="floating">{{ label }}</ion-label>
  }

  <ion-input type="tel" mode="ios" autocomplete="off" [formControl]="formCtrl" [required]="required" [inputmode]="'tel'">
    <ion-select
      slot="start"
      class="phone-code"
      interface="alert"
      [formControl]="phoneCodeCtrl"
      [selectedText]="phoneCodeCtrl.value"
      [attr.phone-code]="phoneCodeCtrl.value"
      [interfaceOptions]="{ cssClass: 'phone-code-flags' }"
    >
      @for (country of countries; track country.value) {
        <ion-select-option [value]="country.value"> {{ country.value }} - {{ country.text }} </ion-select-option>
      }
    </ion-select>
  </ion-input>
  <ion-buttons slot="end" class="phone-actions">
    <ng-content select="[slot=button]"></ng-content>
  </ion-buttons>
</ion-item>
<mom-validation-text [formCtrl]="formCtrl"></mom-validation-text>
